var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8aaffc8dad32295d34be32f9e3ce0fa736f1aa82"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@subcontractorhub"]={id:"8aaffc8dad32295d34be32f9e3ce0fa736f1aa82"};
      